// Promo code schemas (architecture.md §8.3 promo_codes, §24 M8).
// Host codes: scope=host_appointment. Platform codes: scope=platform (admin only).
import { z } from 'zod';
import { promoCodeString, isoDateTime, uuid } from './common.js';
import { PROMO_DISCOUNT, PROMO_APPLICABLE } from '../enums.js';

export const createHostPromoSchema = z
  .object({
    code: promoCodeString,
    discount_type: z.enum(PROMO_DISCOUNT),
    discount_value: z.number().min(0),
    applicable_to: z.enum(PROMO_APPLICABLE).default('all'),
    max_uses: z.number().int().positive().optional().nullable(),
    expires_at: isoDateTime.optional().nullable(),
    is_disabled: z.boolean().default(false),
  })
  .superRefine((p, ctx) => {
    if (p.discount_type === 'percentage' && p.discount_value > 100) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['discount_value'],
        message: 'Percentage discount cannot exceed 100',
      });
    }
  });

// Platform promo (Super Admin). Like the host promo, plus an optional plan_id: when set,
// the promo is scoped to that plan's upgrade; when null it's appointment-scoped
// (applicable_to). Scope='platform' is set server-side.
export const createPlatformPromoSchema = z
  .object({
    code: promoCodeString,
    discount_type: z.enum(PROMO_DISCOUNT),
    discount_value: z.number().min(0),
    applicable_to: z.enum(PROMO_APPLICABLE).default('all'),
    plan_id: uuid.optional().nullable(),
    max_uses: z.number().int().positive().optional().nullable(),
    expires_at: isoDateTime.optional().nullable(),
    is_disabled: z.boolean().default(false),
  })
  .superRefine((p, ctx) => {
    if (p.discount_type === 'percentage' && p.discount_value > 100) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['discount_value'],
        message: 'Percentage discount cannot exceed 100',
      });
    }
  });

// Toggle a platform promo's disabled flag.
export const updatePlatformPromoSchema = z.object({
  is_disabled: z.boolean(),
});

// Public: validate a code against a booking amount.
export const validatePromoSchema = z.object({
  code: promoCodeString,
});
